<div class="bestwallet">
  <div class="content">
    <div class="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center gap-3">
      <svg-icon src="/assets/images/svg-icons/token.svg" [svgStyle]="{ 'width.px': 70, 'height.px': 70 }"></svg-icon>
      <div class="w-100">
        <h2 class="text-center text-md-start mb-1 d-none d-md-block font-19 font-md-20 fw-light">{{ 'bw_modal.title' | translate }}</h2>
        <h2 class="text-center text-md-start mb-1 d-block d-md-none font-19 font-md-20 fw-light">{{ 'bw_modal.title_mob' | translate }}</h2>
        <p class="text-center text-md-start font-11 font-md-13 mb-2 mb-md-0">{{ 'bw_modal.sub_title_other' | translate }}</p>
      </div>
      <svg-icon src="/assets/images/bestwallet_modal/modal_close.svg" class="cursor-pointer modalClose" (click)="modalRef.hide()"></svg-icon>
    </div>

    <!-- ====== desktop + mobile mode ===== -->

    <div class="content_holder">
      <div class="info_holder">
        <img src="/assets/images/bestwallet_modal/desktop_bestwallet.png" alt="desktop wallet" loading="lazy" class="left-img d-none d-md-block" *ngIf="!isBw" />
        <img src="/assets/images/bestwallet_modal/desktop_bestwallet_isBw.png" alt="desktop wallet" loading="lazy" class="left-img d-none d-md-block" *ngIf="isBw" />
        <img src="/assets/images/bestwallet_modal/mobile_bestwallet.png" alt="mobile wallet" loading="lazy" class="left-img d-block d-md-none" />
        <div class="right_pannel">
          <div class="info_content">
            <div class="mb-2 font-16 fw-bold">{{ 'bw_modal.info_header' | translate }}</div>
            <div class="font-14 mb-3 fw-bold" *ngIf="!isBw">{{ 'bw_modal.info_title' | translate }}</div>
            <div class="font-14 mb-3 fw-regular" *ngIf="isBw">{{ 'bw_modal.info_title_isBw' | translate }}</div>
            <ul [ngClass]="{ isBw: isBw }">
              <li>{{ 'bw_modal.info_1' | translate }}</li>
              <li>{{ 'bw_modal.info_2' | translate }}</li>
              <li>{{ 'bw_modal.info_3' | translate }}</li>
            </ul>

            <a href="{{post_presale_singular_link}}" target="_blank" type="button" class="btn btn-bestwallet w-100 w-md-75 mt-4 d-block d-md-none">
              {{ (isBw ? 'bw_modal.info_title_isBw' : 'bw_modal.download_bw') | translate }}
            </a>
          </div>

          <!-- ---- for other wallet success ---- -->

          <div class="d-none d-md-flex align-items-start justify-content-around mb-4 gap-3 w-100" *ngIf="!isBw">
            <div class="d-flex flex-column align-items-center justify-content-center block">
              <div class="qr-cont">
                <img src="/assets/images/bestwallet_modal/post_presale_qrcode.svg" alt="post presale qr code" loading="lazy" class="qr-img" />
              </div>
              <p>{{ 'bw_modal.step_1' | translate }}</p>
            </div>

            <div class="d-flex flex-column align-items-center justify-content-center block">
              <img src="/assets/images/bestwallet_modal/icon_collage.svg" alt="setp 2" loading="lazy" class="blockPic" />
              <p>{{ 'bw_modal.step_2' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
